setTimeout(function(){
    buyItNowButtonsCollection = document.getElementsByClassName('shopify-payment-button__button');
    if(buyItNowButtonsCollection.length) {
		buyItNowButton = buyItNowButtonsCollection[0];
		buyItNowButton.textContent = 'לרכישה מהירה';
        document.querySelector('.shopify-payment-button').style.display = 'block'
    }
}, 1000);

setTimeout(function(){
    buyItNowButtonsCollection = document.getElementsByClassName('shopify-payment-button__button--unbranded');
    if(buyItNowButtonsCollection.length) {
		buyItNowButton = buyItNowButtonsCollection[0];
		buyItNowButton.textContent = 'לרכישה מהירה';
    }
}, 2000);

document.addEventListener("DOMContentLoaded", function () {
  var OMNI_FORM_ID = '68fe6476929eb87ea93a7cf0'; 
  var STORAGE_KEY = 'omni_pre_checkout_shown_v1'; 
  var SHOW_ONCE_FOR_MINUTES = Infinity; 
  const checkout_button = document.querySelector('.btn[name="checkout"]')
  const checkbox = document.getElementById("accept-terms");
  
  function hasShown() {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      if (!val) return false;
      var data = JSON.parse(val);
      if (!data || !data.ts) return true;
      if (SHOW_ONCE_FOR_MINUTES === Infinity) return true;
      var mins = (Date.now() - data.ts) / 60000;
      return mins < SHOW_ONCE_FOR_MINUTES;
    } catch (e) { return true; }
  }
  function markShown() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now() })); } catch (e) {}
  }

  function openOmnisend() {
    window.omnisend = window.omnisend || [];
    try { window.omnisend.push(['openForm', OMNI_FORM_ID]); } catch(e) {}
  }

  if (checkout_button) {
    const errorMessage = document.createElement("div");
    errorMessage.textContent = "יש לאשר את תנאי השימוש לפני המשך";
    errorMessage.style.color = "red";
    errorMessage.style.fontSize = "1.4rem";
    errorMessage.style.lineHeight = "1";
    errorMessage.style.display = "none";

    // Insert the error message after the checkbox container
    const checkboxContainer = checkbox.closest("div");
    checkboxContainer.appendChild(errorMessage);
    
    checkout_button.addEventListener('click', function(e) {
      e.preventDefault()
      if (!checkbox.checked) {
        errorMessage.style.display = "block";
      } else {
        errorMessage.style.display = "none";
        if (!hasShown()) {
          window.omnisend = window.omnisend || [];
          window.omnisend.push(['openForm', '68fe6476929eb87ea93a7cf0']);
          markShown()
        } else {
          window.location.href = '/checkout'
        }
      }
    })

    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        errorMessage.style.display = "none";
      }
    });
  }
});

function add_gift_wrap(e, el) {
  e = e || window.event;
  e.preventDefault();

  const from = document.querySelector('#CartGiftForm-from')
  const to = document.querySelector('#CartGiftForm-to')
  const message = document.querySelector('#CartGiftForm-message')

  let formData = new FormData();
  formData.append('items[0][id]', '45990095880479');
  formData.append('items[0][quantity]', 1);
  formData.append('items[0][properties][מאת]', from.value);
  formData.append('items[0][properties][אל]', to.value);
  formData.append('items[0][properties][ברכה]', message.value);

  let sectionsToBundle = [];

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
  );

  formData.append('sections', sectionsToBundle);
  formData.append('sections_url', window.location.pathname);

  const config = FoxTheme.utils.fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  el.setAttribute('disabled', 'disabled');

  fetch(`${FoxTheme.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (parsedState) => {
      if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType === 'page') location.reload();
      el.removeAttribute('disabled');
      const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      cartJson['sections'] = parsedState['sections'];
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.documentElement.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: parsedState,
          },
        })
      );
    })
    .catch(err => {
      console.error('Error: ', err);
    });
}

function add_bag_wrap(e, el) {
  e = e || window.event;
  e.preventDefault();

  const from = document.querySelector('#CartBagForm-from')
  const to = document.querySelector('#CartBagForm-to')
  const message = document.querySelector('#CartBagForm-message')

  let formData = new FormData();
  formData.append('items[0][id]', '51582961189151');
  formData.append('items[0][quantity]', 1);
  formData.append('items[0][properties][מאת]', from.value);
  formData.append('items[0][properties][אל]', to.value);
  formData.append('items[0][properties][ברכה]', message.value);

  let sectionsToBundle = [];

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
  );

  formData.append('sections', sectionsToBundle);
  formData.append('sections_url', window.location.pathname);

  const config = FoxTheme.utils.fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  el.setAttribute('disabled', 'disabled');

  fetch(`${FoxTheme.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (parsedState) => {
      if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType === 'page') location.reload();
      el.removeAttribute('disabled');
      const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      cartJson['sections'] = parsedState['sections'];
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.documentElement.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: parsedState,
          },
        })
      );
    })
    .catch(err => {
      console.error('Error: ', err);
    });
}